// extracted by mini-css-extract-plugin
export default {"display-name":"hawk-review-contracts-items-display-name","displayName":"hawk-review-contracts-items-display-name"};